const LOGO_FILE_NAME = {
  EXNESS: 'logo-exness',
  ICM: 'logo-icm',
  ATFX_BLUE: 'logo-atfx-blue',
  IRON_FX: 'logo-iron-fx',
  XM: 'logo-xm',
  B2BINPAY: 'logo-b2binpay',
  ALIBABA: 'logo-alibaba',
  CMC_MARKETS: 'logo-cmc-markets',
  CURRENCYCLOUD_VISA: 'logo-currencycloud-visa',
  FBS: 'logo-fbs',
  IFX: 'logo-ifx',
  MATCH2PAY: 'logo-match2pay',
  PAYMENT_ASIA: 'logo-payment-asia',
  UNLIMIT: 'logo-unlimit',
  PAYABL: 'logo-payabl'
}

const LOGO_ALT_BY_LOGO = {
  [LOGO_FILE_NAME.ALIBABA]: 'Alibaba logo',
  [LOGO_FILE_NAME.ATFX_BLUE]: 'ATFX logo',
  [LOGO_FILE_NAME.B2BINPAY]: 'B2BInPay logo',
  [LOGO_FILE_NAME.CMC_MARKETS]: 'CMC Markets logo',
  [LOGO_FILE_NAME.CURRENCYCLOUD_VISA]: 'Currencycloud Visa logo',
  [LOGO_FILE_NAME.FBS]: 'FBS logo',
  [LOGO_FILE_NAME.XM]: 'XM logo',
  [LOGO_FILE_NAME.EXNESS]: 'Exness logo',
  [LOGO_FILE_NAME.ICM]: 'ICM logo',
  [LOGO_FILE_NAME.IFX]: 'IFX logo',
  [LOGO_FILE_NAME.IRON_FX]: 'Iron FX logo',
  [LOGO_FILE_NAME.MATCH2PAY]: 'Match2Pay logo',
  [LOGO_FILE_NAME.PAYMENT_ASIA]: 'Payment Asia logo',
  [LOGO_FILE_NAME.UNLIMIT]: 'Unlimit logo',
  [LOGO_FILE_NAME.PAYABL]: 'Payabl logo'
}

function enrichLogoWithSettings(logo) {
  return {
    url: `/images/${logo}.svg`,
    alt: LOGO_ALT_BY_LOGO[logo]
  }
}

export const LOGOS_SETTINGS = Object.values(LOGO_FILE_NAME).map(
  enrichLogoWithSettings
)

export const PAGINATION_CUSTOM_CLASS = 'swiper-pagination-trusted-by'
